import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const GoogleLogin = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://accounts.google.com/gsi/client";
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);

    script.onload = () => {
      window.google.accounts.id.initialize({
        client_id:
          "330942469308-moicjo9j6v9ceflpa9a84j43bd2o6adp.apps.googleusercontent.com",
        callback: handleCredentialResponse,
      });

      window.google.accounts.id.renderButton(
        document.getElementById("google-sign-in"),
        { theme: "outline", size: "large" },
      );
    };

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  const decodeJwtResponse = (token) => {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      window
        .atob(base64)
        .split("")
        .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join(""),
    );

    return JSON.parse(jsonPayload);
  };

  const handleCredentialResponse = (response) => {
    const responsePayload = decodeJwtResponse(response.credential);

    const userEmail = responsePayload.email;
    const allowedDomains = ["technoso.co.il", "blueparking.co.il"];

    if (allowedDomains.some((domain) => userEmail.endsWith(`@${domain}`))) {
      localStorage.setItem("googleAuthToken", response.credential);
      navigate("/management");
    } else {
      alert(
        "Access denied: Only users with @blueparking.co.il email can access this page.",
      );
    }
  };

  return (
    <div>
      <h1>Blue Parking</h1>
      <div id="google-sign-in" style={{ margin: "20px 0" }} />
    </div>
  );
};

export default GoogleLogin;
